import { render, staticRenderFns } from "./Halloween.vue?vue&type=template&id=5820c544&scoped=true&"
import script from "./Halloween.vue?vue&type=script&lang=js&"
export * from "./Halloween.vue?vue&type=script&lang=js&"
import style0 from "./Halloween.vue?vue&type=style&index=0&id=5820c544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820c544",
  null
  
)

export default component.exports